<!--
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-10-28 15:10:24
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-16 16:08:21
 * @FilePath: /wxkn-experience/src/components/Tabbar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="tabbar-box">
        <div class="tabbar-item" v-for="(item,index) in tabbars" :key="index" @click="tabTapAction(item,index)">
            <div class="icon-box">
                <img :src="item.isSelected ? item.selectIcon : item.icon"/>
            </div>
            <div :class="item.isSelected ? 'item-name-active' : 'item-name'">
             {{item.name}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabbars: [{
                    icon: require('@/assets/miImgs/tabbars/home.png'),
                    selectIcon: require('@/assets/miImgs/tabbars/home-select.png'),
                    path: '',
                    isSelected: true,
                    name: '首页'
                }, {
                    icon: require('@/assets/miImgs/tabbars/plaza.png'),
                    selectIcon: require('@/assets/miImgs/tabbars/plaza-select.png'),
                    path: '',
                    isSelected: false,
                    name: '广场'
                }],
                itemWidth: 0
            }
        },

        mounted() {


        },
        methods: {
            tabTapAction(e, index) {
                // console.log('e', e)
                // e.isSelected = true;
                this.tabbars.forEach(item => {
                    if (item.name != e.name) {
                        item.isSelected = false;
                    } else {
                        item.isSelected = true;
                    }
                });
                this.$emit('tabbarIndex', index);

            }

        },

    }
</script>

<style lang="scss" scoped>
    .tabbar-box {
        display: flex;
        bottom: 0;
        left: 0;
        right: 0;
        height: 49px;
        position: fixed;
        justify-content: space-between;
        border-top: solid 1px #efefef;
        background: #fff;
        z-index: 99;
    }
    
    .tabbar-item {
        /* font-size: 14px; */
        width: 50%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        .icon-box {
            width: 1.2em;
            height: 1.2em;
            margin-bottom: 3px;
            img {
                height: 100%;
                width: 100%;
            }
        }
        .item-name {
            font-size: 14px;
            color: #666666;
        }
        .item-name-active {
            font-size: 16px;
            color: #3d7eff;
            font-weight: 600;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Tabbar.vue